import { FormikProps } from "formik";
import Flex from "../../../../../components/Flex";
import { RosTemplate } from "../../../../../services";
import { Box } from "@mui/material";
import CustomTooltip from "../../../../../components/CustomTooltip";
import DynamicVariablesTooltip from "./DynamicVariablesTooltipForEmail";
import RichTextEditor from "../../../../../components/richTextEditor/RichTextEditor";
import Text from "../../../../../components/Text";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface SmsFormProps {
  formik: FormikProps<RosTemplate>;
  disabled?: boolean;
}

const SmsForm = ({ formik, disabled }: SmsFormProps) => (
  <Flex gap={2} flexDirection={"column"} mt={2}>
    {!disabled && (
      <Box sx={{ flex: "0 0 auto", alignSelf: "flex-start" }}>
        <CustomTooltip
          content={<DynamicVariablesTooltip />}
          position="right-end"
          disableTooltip={false}
          width="500px"
        >
          <Text>
            Dynamic Variables <InfoOutlinedIcon fontSize="small" />
          </Text>
        </CustomTooltip>
      </Box>
    )}
    <RichTextEditor
      disabled={disabled}
      minRows={20}
      name="description"
      placeholder="Type Something..."
      onBlur={formik.handleBlur}
      value={formik.values?.description}
      onChange={formik.handleChange}
      error={
        formik.touched?.description && formik.errors?.description
          ? formik.errors?.description
          : undefined
      }
    />
  </Flex>
);

export default SmsForm;
